const courseAssess = {
  en: {
    quizzes: {
      pageTitle: 'Course tests',
      pageLead: 'A quiz per lesson checks understanding before students move on.',
      createQuiz: 'Create quiz',
      editQuiz: 'Edit quiz',
      newQuiz: 'New quiz',
      questionCount: '{count} question',
      questionCount_plural: '{count} questions',
      lessonNumberBadge: 'Lesson #{index}',
      minutesBadge: '{count} min',
      saveChanges: 'Save changes',
      lessonLabel: 'Lesson',
      selectLessonPlaceholder: 'Select a lesson...',
      passingScoreLabel: 'Passing score',
      timeLimitLabel: 'Time limit',
      noLimit: 'No limit',
      minutesOption: '{count} minutes',
      perQuestionEstimate: '~{seconds}s per question',
      quickNavLabel: 'Quick nav',
      openSettingsTooltip: 'Quiz settings',
      closeSettingsTooltip: 'Close settings',
      settingsDrawerTitle: 'Quiz settings',
      questionTitle: 'Question {index}',
      addQuestionTooltip: 'Add question',
      noQuestionsTitle: 'No questions yet',
      noQuestionsDesc: 'Add the first question; you can add more later.',
      dragToReorder: 'Drag to reorder',
      duplicateTooltip: 'Duplicate',
      deleteTooltip: 'Delete',
      questionPlaceholder: 'Type your question here...',
      answerOptionsLabel: 'Answer options',
      addOption: 'Add option',
      optionPlaceholder: 'Option {letter}',
      markCorrectTooltip: 'Mark {letter} as correct',
      removeOptionTooltip: 'Remove option {letter}',
      explanationLabel: 'Explanation',
      explanationHint: '(shown after answer)',
      explanationPlaceholder: "Why is this the correct answer? (optional)",
      addQuestion: 'Add question',
      totalTests: 'Total tests',
      coverage: 'Coverage',
      withoutTest: 'Without a test',
      modules: 'Modules',
      searchPlaceholder: 'Search lessons or quizzes...',
      allModules: 'All modules',
      sortLessonOrder: 'Lesson order',
      sortMissingFirst: 'Missing first',
      sortAlpha: 'Alphabetical',
      noResultsSearch: 'No results match your search.',
      noLessonsFound: 'No lessons found',
      noLessonsFoundDesc: 'Add lessons to this course first.',
      clearFiltersAction: 'Clear filters',
      noModuleGroup: 'No module',
      lessonsCountLabel: '{count} lesson',
      lessonsCountLabel_plural: '{count} lessons',
      quizzesCountLabel: '{count} quiz',
      quizzesCountLabel_plural: '{count} quizzes',
      missingPill: '{count} missing',
      completePill: 'Complete',
      colLesson: 'Lesson',
      colQuestions: 'Questions',
      colTimer: 'Timer',
      colPass: 'Pass',
      colActions: 'Actions',
      resultsLink: 'Results',
      editAction: 'Edit',
      deleteAction: 'Delete',
      createQuizForLesson: 'Create quiz',
      loadingTests: 'Loading tests...',
      accessDenied: "You don't have access to view these tests.",
      quizDeleted: 'Quiz deleted',
      deleteFailed: 'Failed to delete',
      addQuestionBeforeSave: 'Add at least one question before saving.',
      questionsNoText: '{count} question has no text.',
      questionsNoText_plural: '{count} questions have no text.',
      questionNeedsOptions: 'Each question needs at least 2 options.',
      questionNeedsCorrectAnswer: 'Each question needs a correct answer: mark one of its options.',
      versionConflict: 'Someone else changed this quiz while you were editing. The list has been refreshed: go back, open the quiz again and redo your changes.',
      defaultPassMarkTooltip: 'Default pass mark: no custom value is set for this test.',
      selectLessonForQuiz: 'Select a lesson for this quiz.',
      quizSaved: 'Quiz saved',
      quizCreated: 'Quiz created',
      saveQuizFailed: 'Failed to save quiz',
      createQuizBtn: 'Create quiz',
      createDisabledHint: 'Every lesson already has a quiz',
      deleteTitle: 'Delete this quiz?',
      deleteDesc: 'Historical attempts will be preserved.',
      backToList: 'Back to the tests',
      sortLabel: 'Sort',
      lessonsTableAria: 'Lessons and their quizzes',
      moreActions: 'More actions',
      discardTitle: 'Leave without saving?',
      discardDesc: 'Your changes will be lost.',
      discardAction: 'Leave',
    },
    results: {
      pageTitle: 'Quiz results & analytics',
      backToQuizzes: 'Back to tests',
      loadingResults: 'Loading results...',
      accessDenied: "You don't have access to view these results.",
      loadAttemptFailed: 'Failed to load attempt details',
      averageScore: 'Average score',
      totalAttempts: 'Total attempts',
      passRate: 'Pass rate',
      strugglingStudents: 'Struggling students',
      scoreDistribution: 'Score distribution',
      noStrugglingTitle: 'No struggling students',
      noStrugglingDesc: 'Every student averages {percent}% or higher.',
      attemptHistory: 'Attempt history',
      noAttemptsTitle: 'No attempts yet',
      noAttemptsDesc: 'Once students take this quiz, their attempts and scores will appear here.',
      colStudentName: 'Student name',
      unknownStudent: 'Unknown student',
      colScore: 'Score',
      colDate: 'Date',
      colAttemptNum: 'Attempt #',
      colAttemptShort: '#',
      colStatus: 'Status',
      colAction: 'Action',
      statusPassed: 'Passed',
      statusFailed: 'Failed',
      viewDetails: 'View details',
      attemptDetailsTitle: 'Attempt details',
      score: 'Score',
      submitted: 'Submitted',
      status: 'Status',
      answersReview: 'Answers review',
      studentAnswer: "Student's answer",
      correctAnswer: 'Correct answer',
      noAnswer: 'No answer',
      pageSub: 'Attempts, scores and how each student is doing.',
      strugglingHint: 'Average below {percent}%',
      passRateHint: 'Share of attempts that passed',
      averageHint: 'Across all attempts',
      attemptsHint: '{count} student',
      attemptsHint_plural: '{count} students',
      tooltipAttempts: 'Attempts',
      chartDesc: 'Attempts by score range',
      attemptsTableAria: 'Attempts table',
      insightsDesc: 'Students whose average is below {percent}%.',
      attemptCount: '{count} attempt',
      attemptCount_plural: '{count} attempts',
      moreStudents: '{count} more',
      questionLabel: 'Q{index}',
    },
    exams: {
      pageLead: 'Create the final exam and an exam for each module. Add questions, set passing scores and time limits.',
      newExam: 'New exam',
      totalExams: 'Total exams',
      published: 'Published',
      drafts: 'Drafts',
      modulesWithoutExam: 'Modules without exam',
      loadingExams: 'Loading exams...',
      loadExamsFailed: 'Failed to load exams',
      accessDenied: "You don't have access to view these exams.",
      finalExamSection: 'Final exam',
      finalExamSectionDesc: 'One summative exam taken at the end of the course.',
      noFinalExamTitle: 'No final exam yet',
      noFinalExamDesc: 'The final exam wraps up the course with a summative assessment.',
      createFinalExamAction: 'Create final exam',
      moduleExamsSection: 'Module exams',
      moduleExamsSectionDesc: 'Each module can have its own exams, at its end or between its lessons.',
      noModulesTitle: 'No modules yet',
      noModulesDesc: 'Create modules first under the Modules tab — each module can then have its own exam.',
      addExamForModule: 'Add exam',
      practiceExamsSection: 'Practice exams',
      practiceExamsSectionDesc: 'Optional self-tests not tied to a specific module.',
      statusPublished: 'Published',
      statusArchived: 'Archived',
      statusDraft: 'Draft',
      unpublish: 'Unpublish',
      publish: 'Publish',
      edit: 'Edit',
      review: 'Review',
      reviewWithCount: 'Review ({count})',
      delete: 'Delete',
      editExamTitle: 'Edit exam',
      newExamTitle: 'New exam',
      formSubtitle: 'Set the exam settings and rules, then add its questions.',
      examScopeLabel: 'Exam scope',
      finalExamOption: 'Final exam',
      finalExamOptionSub: 'End-of-course summative',
      moduleExamOption: 'Module exam',
      moduleExamOptionSub: 'Tied to one module',
      practiceOption: 'Practice',
      practiceOptionSub: 'Optional self-test',
      moduleLabel: 'Module',
      selectModulePlaceholder: 'Select a module...',
      placementLabel: 'Where it sits',
      placementEnd: 'At the end of the module',
      placementAfter: 'After lesson {index}: {title}',
      placementAfterShort: 'After lesson {index}',
      placementHint: 'The exam opens once the lessons before it are done. It does not lock the next lessons.',
      categoryLabel: 'Category',
      categoryGeneral: 'General',
      categoryLanguage: 'Language',
      categoryMath: 'Math',
      subcategoryLabel: 'Subcategory',
      difficultyLabel: 'Difficulty',
      difficultyEasy: 'Easy',
      difficultyMedium: 'Medium',
      difficultyHard: 'Hard',
      difficultyMixed: 'Mixed',
      examKindLabel: 'Exam kind',
      examKindCheckpoint: 'Checkpoint',
      examKindMock: 'Mock exam',
      examKindDrill: 'Practice drill',
      examKindChallenge: 'Challenge',
      examKindPlacement: 'Placement',
      titleLabel: 'Title',
      titlePlaceholder: 'e.g. Module 1 — Foundations',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Short summary shown to students before they start.',
      examInstructionsLabel: 'Instructions',
      examInstructionsPlaceholder: 'Shown to students on the exam page before they start.',
      passingScoreLabel: 'Passing score (%)',
      timeLimitLabel: 'Time limit (min)',
      timeLimitPlaceholder: 'No limit',
      maxAttemptsLabel: 'Max attempts',
      maxAttemptsPlaceholder: 'Unlimited',
      sectionsLabel: 'Sections',
      sectionsDesc: 'Group questions by skill, topic, or exam part.',
      addSection: 'Add section',
      newSectionDefaultTitle: 'New section',
      noSectionsYet: 'No sections yet. Questions can still be added directly.',
      sectionTitlePlaceholder: 'Section title',
      skillSlugPlaceholder: 'Skill slug',
      instructionsPlaceholder: 'Instructions',
      removeSection: 'Remove',
      questionsLabel: 'Questions',
      questionsDesc: 'Add selected-response and constructed-response questions.',
      addQuestion: 'Add question',
      noQuestionsYet: 'No questions yet. The exam stays as a draft until questions are added.',
      questionNumber: 'Question {index}',
      removeQuestion: 'Remove',
      questionPromptPlaceholder: 'Question prompt',
      typeLabel: 'Type',
      sectionLabel: 'Section',
      noSectionOption: 'No section',
      pointsLabel: 'Points',
      optionsLabel: 'Options or items',
      optionsOrItemsPlaceholder: 'One per line, in order',
      matchingPairsLabel: 'Pairs',
      acceptedAnswersLabel: 'Accepted answers',
      correctAnswersLabel: 'Correct answers',
      correctAnswerLabel: 'Correct answer',
      toleranceLabel: 'Tolerance',
      rubricLabel: 'Rubric',
      explanationLabel: 'Explanation',
      matchingPairsPlaceholder: 'One per line: left=right',
      acceptedAnswersPlaceholder: 'One per line',
      correctAnswersOrderPlaceholder: 'One per line, in order',
      correctAnswerPlaceholder: 'Type the answer',
      tolerancePlaceholder: 'e.g. 0.01',
      rubricPlaceholder: 'Rubric rows: criterion:points:description',
      explanationPlaceholder: 'Shown when answers are revealed',
      behaviourLabel: 'Exam rules',
      showResultsLabel: 'Show results after submit',
      showResultsHint: 'Students see their score immediately.',
      showAnswersLabel: 'Reveal correct answers',
      showAnswersHint: 'Students can review correct answers after grading.',
      shuffleQuestionsLabel: 'Shuffle questions',
      shuffleQuestionsHint: 'Each attempt shows questions in a random order.',
      shuffleOptionsLabel: 'Shuffle options',
      shuffleOptionsHint: 'Multiple-choice options appear in a random order.',
      cancel: 'Cancel',
      saveChanges: 'Save changes',
      createExam: 'Create exam',
      reviewAttempts: 'Review attempts',
      loadingAttempts: 'Loading attempts...',
      noManualQuestionsTitle: 'No manual questions',
      noManualQuestionsDesc: 'This exam is fully auto-graded.',
      noSubmittedAttemptsTitle: 'No submitted attempts',
      noSubmittedAttemptsDesc: 'Submitted writing or speaking attempts will appear here.',
      finalizeGrade: 'Finalize grade',
      scoreOutOf: 'Score / {points}',
      noAnswerText: 'No answer',
      close: 'Close',
      attemptStatus: {
        SUBMITTED: 'Submitted',
        GRADED: 'Graded',
        IN_PROGRESS: 'In progress',
        EXPIRED: 'Expired',
      },
      loadAttemptsFailed: 'Failed to load attempts',
      gradeAttemptFailed: 'Failed to grade attempt',
      saveExamFailed: 'Failed to save exam',
      changeStatusFailed: 'Failed to change status',
      deleteExamFailed: 'Failed to delete exam',
      discardTitle: 'Leave without saving?',
      discardDesc: 'Your changes will be lost.',
      discardAction: 'Leave',
      questionType: {
        MULTIPLE_CHOICE: 'Multiple choice',
        MULTI_SELECT: 'Multi-select',
        TRUE_FALSE: 'True / false',
        FILL_BLANK: 'Fill blank',
        SHORT_ANSWER: 'Short answer',
        NUMERIC: 'Numeric',
        MATCHING: 'Matching',
        ORDERING: 'Ordering',
        ESSAY: 'Writing / essay',
        SPEAKING: 'Speaking',
      },
      category: {
        checkpoint: 'Checkpoint',
        review: 'Review',
        grammar: 'Grammar',
        vocabulary: 'Vocabulary',
        reading: 'Reading',
        listening: 'Listening',
        writing: 'Writing',
        speaking: 'Speaking',
        concepts: 'Concepts',
        proceduralFluency: 'Procedural fluency',
        wordProblems: 'Word problems',
        reasoning: 'Reasoning',
        algebra: 'Algebra',
        geometry: 'Geometry',
        data: 'Data',
        general: 'General',
      },
      addExamForModuleNamed: 'Add an exam for {module}',
      modulesWithoutExamDesc: 'These modules do not have an exam yet.',
      deleteExamQuestion: 'Delete this exam?',
      deleteExamDesc: '{title}: all questions and student attempts will be removed. This cannot be undone.',
      publishedToast: 'Exam published',
      unpublishedToast: 'Exam unpublished',
      examSavedToast: 'Exam saved',
      examDeletedToast: 'Exam deleted',
      gradeSavedToast: 'Grade saved',
      questionsStat: '{count} question',
      questionsStat_plural: '{count} questions',
      passStat: '{percent}% to pass',
      timeStat: '{count} min',
      noTimeStat: 'No time limit',
    },
    games: {
      pageSubtitle: 'Interactive story & puzzle games attached to your lessons.',
      gameCountLabel: '{count} game',
      gameCountLabel_plural: '{count} games',
      loadingGames: 'Loading games...',
      accessDenied: "You don't have access to view these games.",
      gamesInLesson: '{count} game in this lesson',
      gamesInLesson_plural: '{count} games in this lesson',
      newGame: 'New game',
      addGame: 'Add game',
      lessonLabel: 'Lesson',
      selectLessonPlaceholder: 'Select a lesson...',
      gameTitleLabel: 'Game title',
      descriptionLabel: 'Description',
      noGamesForLesson: 'No games for this lesson yet.',
      noLessonsTitle: 'No lessons to attach games to',
      noLessonsDesc: 'Add a lesson in the Lessons tab first — games are built on top of lessons.',
      gameTitlePlaceholder: 'Game title...',
      descriptionPlaceholder: 'Optional description...',
      cancel: 'Cancel',
      create: 'Create',
      delete: 'Delete',
      gameCreated: 'Game created',
      createGameFailed: 'Failed to create game',
      gameDeleted: 'Game deleted',
      deleteGameFailed: 'Failed to delete',
      nodesCount: 'Steps: {count}',
      addNode: 'Add a step',
      nodeTextPlaceholder: 'What the student reads at this step...',
      pointsPlaceholder: 'Pts',
      startLabel: 'First step',
      add: 'Add',
      addNodeFailed: "Couldn't add the step",
      addChoiceFailed: 'Failed to add choice',
      noNodesHint: 'No steps yet. Add the first step: it is where the story starts.',
      startBadge: 'First step',
      pointsSuffix: 'pts',
      choiceLabelPlaceholder: 'Choice label...',
      leadsToPlaceholder: 'Next step...',
      gameTypeLabel: 'Game type',
      nodeTypeLabel: 'Kind of step',
      addChoice: 'Add choice',
      puzzlesCount: 'Puzzles: {count}',
      addPuzzle: 'Add puzzle',
      addPuzzleFailed: 'Failed to add puzzle',
      questionPromptLabel: 'Question / prompt',
      questionPromptPlaceholder: 'What question will the student see?',
      correctAnswerLabel: 'Correct answer',
      correctAnswerPlaceholder: 'Expected answer',
      hintsLabel: 'Hints (one per line)',
      hintsPlaceholder: 'Optional hints',
      pointsLabel: 'Points',
      addPuzzleBtn: 'Add puzzle',
      noPuzzlesHint: 'No puzzles yet. Add the first puzzle to start.',
      answerLabel: 'Answer:',
      hintsPrefix: 'Hints:',
      nodeType: {
        PROMPT: 'Step with choices',
        TERMINAL: 'Story ending',
      },
      gameType: {
        STORY_ADVENTURE: 'Story adventure',
        PUZZLE_MASTER: 'Puzzle master',
        SIMULATOR: 'Simulator',
        SKILL_QUEST: 'Skill quest',
        PICTURE_QUIZ: 'Picture quiz',
        MEMORY_MATCH: 'Memory match',
        SENTENCE_BUILDER: 'Sentence builder',
        WORD_SPRINT: 'Word sprint',
      },
      kpiTotal: 'Total games',
      kpiLessons: 'Lessons with games',
      kpiAuthored: 'Authored by hand',
      kpiAuto: 'Automatic',
      deleteTitle: 'Delete this game?',
      deleteDesc: 'This cannot be undone.',
      autoNote: "This game is built automatically from the lesson's vocabulary, so it is not edited here.",
      notEditableNote: 'This type of game cannot be edited here.',
      nodesMeta: '{count} step',
      nodesMeta_plural: '{count} steps',
      puzzlesMeta: '{count} puzzle',
      puzzlesMeta_plural: '{count} puzzles',
    },
    common: {
      close: 'Close',
    },
  },
  ru: {
    quizzes: {
      pageTitle: 'Тесты курса',
      pageLead: 'Тест по каждому уроку проверяет понимание материала, прежде чем студенты пойдут дальше.',
      createQuiz: 'Создать тест',
      editQuiz: 'Редактировать тест',
      newQuiz: 'Новый тест',
      questionCount: '{count} вопрос',
      questionCount_few: '{count} вопроса',
      questionCount_plural: '{count} вопросов',
      lessonNumberBadge: 'Урок №{index}',
      minutesBadge: '{count} мин',
      saveChanges: 'Сохранить изменения',
      lessonLabel: 'Урок',
      selectLessonPlaceholder: 'Выберите урок...',
      passingScoreLabel: 'Проходной балл',
      timeLimitLabel: 'Ограничение по времени',
      noLimit: 'Без ограничения',
      minutesOption: '{count} минут',
      perQuestionEstimate: '~{seconds} сек на вопрос',
      quickNavLabel: 'Быстрая навигация',
      openSettingsTooltip: 'Настройки теста',
      closeSettingsTooltip: 'Закрыть настройки',
      settingsDrawerTitle: 'Настройки теста',
      questionTitle: 'Вопрос {index}',
      addQuestionTooltip: 'Добавить вопрос',
      noQuestionsTitle: 'Пока нет вопросов',
      noQuestionsDesc: 'Добавьте первый вопрос: остальные можно добавить позже.',
      dragToReorder: 'Перетащите, чтобы изменить порядок',
      duplicateTooltip: 'Дублировать',
      deleteTooltip: 'Удалить',
      questionPlaceholder: 'Введите вопрос...',
      answerOptionsLabel: 'Варианты ответа',
      addOption: 'Добавить вариант',
      optionPlaceholder: 'Вариант {letter}',
      markCorrectTooltip: 'Отметить {letter} как правильный',
      removeOptionTooltip: 'Удалить вариант {letter}',
      explanationLabel: 'Объяснение',
      explanationHint: '(показывается после ответа)',
      explanationPlaceholder: 'Почему это правильный ответ? (необязательно)',
      addQuestion: 'Добавить вопрос',
      totalTests: 'Всего тестов',
      coverage: 'Покрытие',
      withoutTest: 'Без теста',
      modules: 'Модули',
      searchPlaceholder: 'Поиск уроков или тестов...',
      allModules: 'Все модули',
      sortLessonOrder: 'Порядок уроков',
      sortMissingFirst: 'Сначала без теста',
      sortAlpha: 'По алфавиту',
      noResultsSearch: 'По вашему запросу ничего не найдено.',
      noLessonsFound: 'Уроки не найдены',
      noLessonsFoundDesc: 'Сначала добавьте уроки в этот курс.',
      clearFiltersAction: 'Сбросить фильтры',
      noModuleGroup: 'Без модуля',
      lessonsCountLabel: '{count} урок',
      lessonsCountLabel_few: '{count} урока',
      lessonsCountLabel_plural: '{count} уроков',
      quizzesCountLabel: '{count} тест',
      quizzesCountLabel_few: '{count} теста',
      quizzesCountLabel_plural: '{count} тестов',
      missingPill: '{count} без теста',
      completePill: 'Готово',
      colLesson: 'Урок',
      colQuestions: 'Вопросы',
      colTimer: 'Таймер',
      colPass: 'Проход',
      colActions: 'Действия',
      resultsLink: 'Результаты',
      editAction: 'Изменить',
      deleteAction: 'Удалить',
      createQuizForLesson: 'Создать тест',
      loadingTests: 'Загрузка тестов...',
      accessDenied: 'У вас нет доступа для просмотра этих тестов.',
      quizDeleted: 'Тест удалён',
      deleteFailed: 'Не удалось удалить',
      addQuestionBeforeSave: 'Добавьте хотя бы один вопрос перед сохранением.',
      questionsNoText: '{count} вопрос без текста.',
      questionsNoText_few: '{count} вопроса без текста.',
      questionsNoText_plural: '{count} вопросов без текста.',
      questionNeedsOptions: 'Каждый вопрос должен содержать минимум 2 варианта ответа.',
      questionNeedsCorrectAnswer: 'У каждого вопроса должен быть правильный ответ: отметьте один из вариантов.',
      versionConflict: 'Пока вы редактировали, этот тест изменил кто-то другой. Список обновлён: вернитесь, откройте тест заново и повторите правки.',
      defaultPassMarkTooltip: 'Проходной балл по умолчанию: для этого теста свой балл не задан.',
      selectLessonForQuiz: 'Выберите урок для этого теста.',
      quizSaved: 'Тест сохранён',
      quizCreated: 'Тест создан',
      saveQuizFailed: 'Не удалось сохранить тест',
      createQuizBtn: 'Создать тест',
      createDisabledHint: 'У каждого урока уже есть тест',
      deleteTitle: 'Удалить этот тест?',
      deleteDesc: 'Прошлые попытки сохранятся.',
      backToList: 'Назад к списку тестов',
      sortLabel: 'Сортировка',
      lessonsTableAria: 'Уроки и их тесты',
      moreActions: 'Другие действия',
      discardTitle: 'Выйти без сохранения?',
      discardDesc: 'Внесённые изменения будут потеряны.',
      discardAction: 'Выйти',
    },
    results: {
      pageTitle: 'Результаты и аналитика тестов',
      backToQuizzes: 'Назад к тестам',
      loadingResults: 'Загрузка результатов...',
      accessDenied: 'У вас нет доступа для просмотра этих результатов.',
      loadAttemptFailed: 'Не удалось загрузить детали попытки',
      averageScore: 'Средний балл',
      totalAttempts: 'Всего попыток',
      passRate: 'Процент прохождения',
      strugglingStudents: 'Отстающие студенты',
      scoreDistribution: 'Распределение баллов',
      noStrugglingTitle: 'Отстающих студентов нет',
      noStrugglingDesc: 'У всех студентов средний балл не ниже {percent}%.',
      attemptHistory: 'История попыток',
      noAttemptsTitle: 'Пока нет попыток',
      noAttemptsDesc: 'Как только студенты пройдут этот тест, их попытки и баллы появятся здесь.',
      colStudentName: 'Имя студента',
      unknownStudent: 'Неизвестный студент',
      colScore: 'Балл',
      colDate: 'Дата',
      colAttemptNum: 'Попытка №',
      colAttemptShort: '№',
      colStatus: 'Статус',
      colAction: 'Действие',
      statusPassed: 'Пройден',
      statusFailed: 'Не пройден',
      viewDetails: 'Подробнее',
      attemptDetailsTitle: 'Детали попытки',
      score: 'Балл',
      submitted: 'Отправлено',
      status: 'Статус',
      answersReview: 'Обзор ответов',
      studentAnswer: 'Ответ студента',
      correctAnswer: 'Правильный ответ',
      noAnswer: 'Нет ответа',
      pageSub: 'Попытки, баллы и результаты студентов.',
      strugglingHint: 'Средний балл ниже {percent}%',
      passRateHint: 'Доля успешных попыток',
      averageHint: 'По всем попыткам',
      attemptsHint: '{count} студент',
      attemptsHint_few: '{count} студента',
      attemptsHint_plural: '{count} студентов',
      tooltipAttempts: 'Попытки',
      chartDesc: 'Попытки по диапазонам баллов',
      attemptsTableAria: 'Таблица попыток',
      insightsDesc: 'Студенты со средним баллом ниже {percent}%.',
      attemptCount: '{count} попытка',
      attemptCount_few: '{count} попытки',
      attemptCount_plural: '{count} попыток',
      moreStudents: 'Ещё {count}',
      questionLabel: 'Вопрос {index}',
    },
    exams: {
      pageLead: 'Создайте итоговый экзамен и экзамен для каждого модуля. Добавьте вопросы, задайте проходной балл и лимит времени.',
      newExam: 'Новый экзамен',
      totalExams: 'Всего экзаменов',
      published: 'Опубликовано',
      drafts: 'Черновики',
      modulesWithoutExam: 'Модули без экзамена',
      loadingExams: 'Загрузка экзаменов...',
      loadExamsFailed: 'Не удалось загрузить экзамены',
      accessDenied: 'У вас нет доступа для просмотра этих экзаменов.',
      finalExamSection: 'Итоговый экзамен',
      finalExamSectionDesc: 'Один итоговый экзамен, который сдаётся в конце курса.',
      noFinalExamTitle: 'Итогового экзамена пока нет',
      noFinalExamDesc: 'Итоговый экзамен завершает курс итоговой оценкой знаний.',
      createFinalExamAction: 'Создать итоговый экзамен',
      moduleExamsSection: 'Экзамены по модулям',
      moduleExamsSectionDesc: 'У каждого модуля могут быть свои экзамены: в конце или между уроками.',
      noModulesTitle: 'Пока нет модулей',
      noModulesDesc: 'Сначала создайте модули на вкладке «Модули» — тогда у каждого модуля появится собственный экзамен.',
      addExamForModule: 'Добавить экзамен',
      practiceExamsSection: 'Практические экзамены',
      practiceExamsSectionDesc: 'Необязательные самотесты, не привязанные к конкретному модулю.',
      statusPublished: 'Опубликован',
      statusArchived: 'В архиве',
      statusDraft: 'Черновик',
      unpublish: 'Снять с публикации',
      publish: 'Опубликовать',
      edit: 'Изменить',
      review: 'Проверка',
      reviewWithCount: 'Проверка ({count})',
      delete: 'Удалить',
      editExamTitle: 'Редактировать экзамен',
      newExamTitle: 'Новый экзамен',
      formSubtitle: 'Задайте настройки и правила экзамена, затем добавьте вопросы.',
      examScopeLabel: 'Охват экзамена',
      finalExamOption: 'Итоговый экзамен',
      finalExamOptionSub: 'Итоговая оценка по завершении курса',
      moduleExamOption: 'Экзамен по модулю',
      moduleExamOptionSub: 'Привязан к одному модулю',
      practiceOption: 'Практика',
      practiceOptionSub: 'Необязательный самотест',
      moduleLabel: 'Модуль',
      selectModulePlaceholder: 'Выберите модуль...',
      placementLabel: 'Где стоит',
      placementEnd: 'В конце модуля',
      placementAfter: 'После урока {index}: {title}',
      placementAfterShort: 'После урока {index}',
      placementHint: 'Экзамен откроется, когда пройдены уроки до него. Следующие уроки он не блокирует.',
      categoryLabel: 'Категория',
      categoryGeneral: 'Общее',
      categoryLanguage: 'Язык',
      categoryMath: 'Математика',
      subcategoryLabel: 'Подкатегория',
      difficultyLabel: 'Сложность',
      difficultyEasy: 'Лёгкий',
      difficultyMedium: 'Средний',
      difficultyHard: 'Сложный',
      difficultyMixed: 'Смешанный',
      examKindLabel: 'Тип экзамена',
      examKindCheckpoint: 'Контрольная точка',
      examKindMock: 'Пробный экзамен',
      examKindDrill: 'Практическая тренировка',
      examKindChallenge: 'Испытание',
      examKindPlacement: 'Определение уровня',
      titleLabel: 'Название',
      titlePlaceholder: 'например, Модуль 1 — Основы',
      descriptionLabel: 'Описание',
      descriptionPlaceholder: 'Краткое описание, которое видят студенты перед началом.',
      examInstructionsLabel: 'Инструкции',
      examInstructionsPlaceholder: 'Показываются студентам на странице экзамена перед началом.',
      passingScoreLabel: 'Проходной балл (%)',
      timeLimitLabel: 'Ограничение по времени (мин)',
      timeLimitPlaceholder: 'Без ограничения',
      maxAttemptsLabel: 'Максимум попыток',
      maxAttemptsPlaceholder: 'Без ограничения',
      sectionsLabel: 'Разделы',
      sectionsDesc: 'Группируйте вопросы по навыку, теме или части экзамена.',
      addSection: 'Добавить раздел',
      newSectionDefaultTitle: 'Новый раздел',
      noSectionsYet: 'Разделов пока нет. Вопросы можно добавлять и без разделов.',
      sectionTitlePlaceholder: 'Название раздела',
      skillSlugPlaceholder: 'Идентификатор навыка',
      instructionsPlaceholder: 'Инструкции',
      removeSection: 'Удалить',
      questionsLabel: 'Вопросы',
      questionsDesc: 'Добавьте вопросы с выбором ответа и вопросы со свободным ответом.',
      addQuestion: 'Добавить вопрос',
      noQuestionsYet: 'Вопросов пока нет. Экзамен останется черновиком, пока не будут добавлены вопросы.',
      questionNumber: 'Вопрос {index}',
      removeQuestion: 'Удалить',
      questionPromptPlaceholder: 'Текст вопроса',
      typeLabel: 'Тип',
      sectionLabel: 'Раздел',
      noSectionOption: 'Без раздела',
      pointsLabel: 'Баллы',
      optionsLabel: 'Варианты или элементы',
      optionsOrItemsPlaceholder: 'По одному на строку, по порядку',
      matchingPairsLabel: 'Пары',
      acceptedAnswersLabel: 'Допустимые ответы',
      correctAnswersLabel: 'Правильные ответы',
      correctAnswerLabel: 'Правильный ответ',
      toleranceLabel: 'Допуск',
      rubricLabel: 'Критерии оценки',
      explanationLabel: 'Объяснение',
      matchingPairsPlaceholder: 'По одной на строку: слева=справа',
      acceptedAnswersPlaceholder: 'По одному на строку',
      correctAnswersOrderPlaceholder: 'По одному на строку, по порядку',
      correctAnswerPlaceholder: 'Введите ответ',
      tolerancePlaceholder: 'например, 0.01',
      rubricPlaceholder: 'Строки критериев: критерий:баллы:описание',
      explanationPlaceholder: 'Показывается при раскрытии ответов',
      behaviourLabel: 'Правила экзамена',
      showResultsLabel: 'Показывать результат после отправки',
      showResultsHint: 'Студенты сразу видят свой балл.',
      showAnswersLabel: 'Показывать правильные ответы',
      showAnswersHint: 'Студенты могут посмотреть правильные ответы после проверки.',
      shuffleQuestionsLabel: 'Перемешивать вопросы',
      shuffleQuestionsHint: 'В каждой попытке вопросы показываются в случайном порядке.',
      shuffleOptionsLabel: 'Перемешивать варианты',
      shuffleOptionsHint: 'Варианты ответов показываются в случайном порядке.',
      cancel: 'Отмена',
      saveChanges: 'Сохранить изменения',
      createExam: 'Создать экзамен',
      reviewAttempts: 'Проверка попыток',
      loadingAttempts: 'Загрузка попыток...',
      noManualQuestionsTitle: 'Нет вопросов для ручной проверки',
      noManualQuestionsDesc: 'Этот экзамен проверяется полностью автоматически.',
      noSubmittedAttemptsTitle: 'Нет отправленных попыток',
      noSubmittedAttemptsDesc: 'Отправленные письменные или устные попытки появятся здесь.',
      finalizeGrade: 'Завершить оценку',
      scoreOutOf: 'Баллы / {points}',
      noAnswerText: 'Нет ответа',
      close: 'Закрыть',
      attemptStatus: {
        SUBMITTED: 'Отправлено',
        GRADED: 'Оценено',
        IN_PROGRESS: 'В процессе',
        EXPIRED: 'Просрочено',
      },
      loadAttemptsFailed: 'Не удалось загрузить попытки',
      gradeAttemptFailed: 'Не удалось выставить оценку за попытку',
      saveExamFailed: 'Не удалось сохранить экзамен',
      changeStatusFailed: 'Не удалось изменить статус',
      deleteExamFailed: 'Не удалось удалить экзамен',
      discardTitle: 'Выйти без сохранения?',
      discardDesc: 'Внесённые изменения будут потеряны.',
      discardAction: 'Выйти',
      questionType: {
        MULTIPLE_CHOICE: 'Один вариант ответа',
        MULTI_SELECT: 'Несколько вариантов ответа',
        TRUE_FALSE: 'Верно / неверно',
        FILL_BLANK: 'Заполнить пропуск',
        SHORT_ANSWER: 'Краткий ответ',
        NUMERIC: 'Числовой',
        MATCHING: 'Сопоставление',
        ORDERING: 'Упорядочивание',
        ESSAY: 'Письменная работа / эссе',
        SPEAKING: 'Устный ответ',
      },
      category: {
        checkpoint: 'Контрольная точка',
        review: 'Повторение',
        grammar: 'Грамматика',
        vocabulary: 'Словарный запас',
        reading: 'Чтение',
        listening: 'Аудирование',
        writing: 'Письмо',
        speaking: 'Говорение',
        concepts: 'Понятия',
        proceduralFluency: 'Отработка навыков',
        wordProblems: 'Текстовые задачи',
        reasoning: 'Логическое мышление',
        algebra: 'Алгебра',
        geometry: 'Геометрия',
        data: 'Данные',
        general: 'Общее',
      },
      addExamForModuleNamed: 'Добавить экзамен для модуля {module}',
      modulesWithoutExamDesc: 'Для этих модулей экзамен ещё не создан.',
      deleteExamQuestion: 'Удалить этот экзамен?',
      deleteExamDesc: '{title}: все вопросы и попытки студентов будут удалены. Это действие необратимо.',
      publishedToast: 'Экзамен опубликован',
      unpublishedToast: 'Экзамен снят с публикации',
      examSavedToast: 'Экзамен сохранён',
      examDeletedToast: 'Экзамен удалён',
      gradeSavedToast: 'Оценка сохранена',
      questionsStat: '{count} вопрос',
      questionsStat_few: '{count} вопроса',
      questionsStat_plural: '{count} вопросов',
      passStat: '{percent}% для сдачи',
      timeStat: '{count} мин',
      noTimeStat: 'Без ограничения времени',
    },
    games: {
      pageSubtitle: 'Интерактивные сюжетные и головоломные игры, привязанные к вашим урокам.',
      gameCountLabel: '{count} игра',
      gameCountLabel_few: '{count} игры',
      gameCountLabel_plural: '{count} игр',
      loadingGames: 'Загрузка игр...',
      accessDenied: 'У вас нет доступа для просмотра этих игр.',
      gamesInLesson: '{count} игра в этом уроке',
      gamesInLesson_few: '{count} игры в этом уроке',
      gamesInLesson_plural: '{count} игр в этом уроке',
      newGame: 'Новая игра',
      addGame: 'Добавить игру',
      lessonLabel: 'Урок',
      selectLessonPlaceholder: 'Выберите урок...',
      gameTitleLabel: 'Название игры',
      descriptionLabel: 'Описание',
      noGamesForLesson: 'В этом уроке пока нет игр.',
      noLessonsTitle: 'Нет уроков для игр',
      noLessonsDesc: 'Сначала добавьте урок на вкладке «Уроки» — игры создаются поверх уроков.',
      gameTitlePlaceholder: 'Название игры...',
      descriptionPlaceholder: 'Необязательное описание...',
      cancel: 'Отмена',
      create: 'Создать',
      delete: 'Удалить',
      gameCreated: 'Игра создана',
      createGameFailed: 'Не удалось создать игру',
      gameDeleted: 'Игра удалена',
      deleteGameFailed: 'Не удалось удалить',
      nodesCount: 'Шагов: {count}',
      addNode: 'Добавить шаг',
      nodeTextPlaceholder: 'Что ученик читает на этом шаге...',
      pointsPlaceholder: 'Баллы',
      startLabel: 'Первый шаг',
      add: 'Добавить',
      addNodeFailed: 'Не удалось добавить шаг',
      addChoiceFailed: 'Не удалось добавить вариант',
      noNodesHint: 'Шагов пока нет. Добавьте первый шаг — с него начинается история.',
      startBadge: 'Первый шаг',
      pointsSuffix: 'баллов',
      choiceLabelPlaceholder: 'Текст варианта...',
      leadsToPlaceholder: 'Следующий шаг...',
      gameTypeLabel: 'Тип игры',
      nodeTypeLabel: 'Вид шага',
      addChoice: 'Добавить вариант',
      puzzlesCount: 'Головоломок: {count}',
      addPuzzle: 'Добавить головоломку',
      addPuzzleFailed: 'Не удалось добавить головоломку',
      questionPromptLabel: 'Вопрос / задание',
      questionPromptPlaceholder: 'Какой вопрос увидит студент?',
      correctAnswerLabel: 'Правильный ответ',
      correctAnswerPlaceholder: 'Ожидаемый ответ',
      hintsLabel: 'Подсказки (по одной на строку)',
      hintsPlaceholder: 'Необязательные подсказки',
      pointsLabel: 'Баллы',
      addPuzzleBtn: 'Добавить головоломку',
      noPuzzlesHint: 'Пока нет головоломок. Добавьте первую, чтобы начать.',
      answerLabel: 'Ответ:',
      hintsPrefix: 'Подсказки:',
      nodeType: {
        PROMPT: 'Шаг с выбором',
        TERMINAL: 'Конец истории',
      },
      gameType: {
        STORY_ADVENTURE: 'Сюжетное приключение',
        PUZZLE_MASTER: 'Мастер головоломок',
        SIMULATOR: 'Симулятор',
        SKILL_QUEST: 'Путь навыков',
        PICTURE_QUIZ: 'Картинная викторина',
        MEMORY_MATCH: 'Найди пару',
        SENTENCE_BUILDER: 'Составь предложение',
        WORD_SPRINT: 'Словесный спринт',
      },
      kpiTotal: 'Всего игр',
      kpiLessons: 'Уроки с играми',
      kpiAuthored: 'Созданные вручную',
      kpiAuto: 'Автоматические',
      deleteTitle: 'Удалить эту игру?',
      deleteDesc: 'Это действие необратимо.',
      autoNote: 'Эта игра автоматически строится из слов урока, поэтому здесь не редактируется.',
      notEditableNote: 'Игру этого типа нельзя редактировать здесь.',
      nodesMeta: '{count} шаг',
      nodesMeta_few: '{count} шага',
      nodesMeta_plural: '{count} шагов',
      puzzlesMeta: '{count} головоломка',
      puzzlesMeta_few: '{count} головоломки',
      puzzlesMeta_plural: '{count} головоломок',
    },
    common: {
      close: 'Закрыть',
    },
  },
  uz: {
    quizzes: {
      pageTitle: 'Kurs testlari',
      pageLead: "Har bir darsdagi test o'quvchilar davom etishdan oldin bilimlarini tekshiradi.",
      createQuiz: 'Test yaratish',
      editQuiz: 'Testni tahrirlash',
      newQuiz: 'Yangi test',
      questionCount: '{count} ta savol',
      questionCount_plural: '{count} ta savol',
      lessonNumberBadge: '{index}-dars',
      minutesBadge: '{count} daq',
      saveChanges: "O'zgarishlarni saqlash",
      lessonLabel: 'Dars',
      selectLessonPlaceholder: 'Darsni tanlang...',
      passingScoreLabel: "O'tish bali",
      timeLimitLabel: 'Vaqt chegarasi',
      noLimit: 'Chegarasiz',
      minutesOption: '{count} daqiqa',
      perQuestionEstimate: 'Har bir savolga ~{seconds} soniya',
      quickNavLabel: 'Tezkor navigatsiya',
      openSettingsTooltip: 'Test sozlamalari',
      closeSettingsTooltip: 'Sozlamalarni yopish',
      settingsDrawerTitle: 'Test sozlamalari',
      questionTitle: '{index}-savol',
      addQuestionTooltip: "Savol qo'shish",
      noQuestionsTitle: "Hozircha savollar yo'q",
      noQuestionsDesc: "Birinchi savolni qo'shing: qolganlarini keyinroq qo'shishingiz mumkin.",
      dragToReorder: "Tartibini o'zgartirish uchun sudrab olib boring",
      duplicateTooltip: 'Nusxalash',
      deleteTooltip: "O'chirish",
      questionPlaceholder: 'Savolingizni shu yerga yozing...',
      answerOptionsLabel: 'Javob variantlari',
      addOption: "Variant qo'shish",
      optionPlaceholder: '{letter} varianti',
      markCorrectTooltip: "{letter} ni to'g'ri deb belgilash",
      removeOptionTooltip: "{letter} variantini o'chirish",
      explanationLabel: 'Izoh',
      explanationHint: "(javobdan keyin ko'rsatiladi)",
      explanationPlaceholder: "Nima uchun bu to'g'ri javob? (ixtiyoriy)",
      addQuestion: "Savol qo'shish",
      totalTests: 'Jami testlar',
      coverage: 'Qamrov',
      withoutTest: 'Testsiz',
      modules: 'Modullar',
      searchPlaceholder: 'Darslar yoki testlarni qidirish...',
      allModules: 'Barcha modullar',
      sortLessonOrder: 'Dars tartibi',
      sortMissingFirst: 'Avval testsizlar',
      sortAlpha: "Alifbo bo'yicha",
      noResultsSearch: 'Qidiruvingizga mos natijalar topilmadi.',
      noLessonsFound: 'Darslar topilmadi',
      noLessonsFoundDesc: "Avval bu kursga darslar qo'shing.",
      clearFiltersAction: 'Filtrlarni tozalash',
      noModuleGroup: 'Modulsiz',
      lessonsCountLabel: '{count} ta dars',
      lessonsCountLabel_plural: '{count} ta dars',
      quizzesCountLabel: '{count} ta test',
      quizzesCountLabel_plural: '{count} ta test',
      missingPill: '{count} ta testsiz',
      completePill: 'Tayyor',
      colLesson: 'Dars',
      colQuestions: 'Savollar',
      colTimer: 'Taymer',
      colPass: "O'tish",
      colActions: 'Amallar',
      resultsLink: 'Natijalar',
      editAction: 'Tahrirlash',
      deleteAction: "O'chirish",
      createQuizForLesson: 'Test yaratish',
      loadingTests: 'Testlar yuklanmoqda...',
      accessDenied: "Sizda bu testlarni ko'rish uchun ruxsat yo'q.",
      quizDeleted: "Test o'chirildi",
      deleteFailed: "O'chirib bo'lmadi",
      addQuestionBeforeSave: "Saqlashdan oldin kamida bitta savol qo'shing.",
      questionsNoText: "{count} ta savolda matn yo'q.",
      questionsNoText_plural: "{count} ta savolda matn yo'q.",
      questionNeedsOptions: "Har bir savolda kamida 2 ta variant bo'lishi kerak.",
      questionNeedsCorrectAnswer: "Har bir savolda to'g'ri javob bo'lishi kerak: variantlardan birini belgilang.",
      versionConflict: "Siz tahrirlayotganingizda bu testni boshqa kishi o'zgartirdi. Ro'yxat yangilandi: orqaga qaytib, testni qayta oching va o'zgarishlarni takrorlang.",
      defaultPassMarkTooltip: "Standart o'tish balli: bu test uchun alohida ball belgilanmagan.",
      selectLessonForQuiz: 'Bu test uchun darsni tanlang.',
      quizSaved: 'Test saqlandi',
      quizCreated: 'Test yaratildi',
      saveQuizFailed: "Testni saqlab bo'lmadi",
      createQuizBtn: 'Test yaratish',
      createDisabledHint: 'Barcha darslarda test bor',
      deleteTitle: "Testni o'chirasizmi?",
      deleteDesc: 'Oldingi urinishlar saqlanib qoladi.',
      backToList: "Testlar ro'yxatiga qaytish",
      sortLabel: 'Saralash',
      lessonsTableAria: 'Darslar va ularning testlari',
      moreActions: 'Boshqa amallar',
      discardTitle: 'Saqlamasdan chiqasizmi?',
      discardDesc: "Kiritilgan o'zgarishlar yo'qoladi.",
      discardAction: 'Chiqish',
    },
    results: {
      pageTitle: 'Test natijalari va tahlili',
      backToQuizzes: 'Testlarga qaytish',
      loadingResults: 'Natijalar yuklanmoqda...',
      accessDenied: "Sizda bu natijalarni ko'rish uchun ruxsat yo'q.",
      loadAttemptFailed: "Urinish tafsilotlarini yuklab bo'lmadi",
      averageScore: "O'rtacha ball",
      totalAttempts: 'Jami urinishlar',
      passRate: "O'tish darajasi",
      strugglingStudents: "Qiynalayotgan o'quvchilar",
      scoreDistribution: 'Ballar taqsimoti',
      noStrugglingTitle: "Qiynalayotgan o'quvchilar yo'q",
      noStrugglingDesc: "Barcha o'quvchilarning o'rtacha bali {percent}% yoki undan yuqori.",
      attemptHistory: 'Urinishlar tarixi',
      noAttemptsTitle: "Hozircha urinishlar yo'q",
      noAttemptsDesc: "O'quvchilar bu testni topshirgach, ularning urinishlari va ballari shu yerda ko'rinadi.",
      colStudentName: "O'quvchi ismi",
      unknownStudent: "Noma'lum o'quvchi",
      colScore: 'Ball',
      colDate: 'Sana',
      colAttemptNum: 'Urinish №',
      colAttemptShort: '№',
      colStatus: 'Holat',
      colAction: 'Amal',
      statusPassed: "O'tdi",
      statusFailed: "O'tmadi",
      viewDetails: "Batafsil ko'rish",
      attemptDetailsTitle: 'Urinish tafsilotlari',
      score: 'Ball',
      submitted: 'Yuborilgan sana',
      status: 'Holat',
      answersReview: "Javoblarni ko'rib chiqish",
      studentAnswer: "O'quvchi javobi",
      correctAnswer: "To'g'ri javob",
      noAnswer: "Javob yo'q",
      pageSub: "Urinishlar, ballar va o'quvchilarning natijalari.",
      strugglingHint: "O'rtacha bali {percent}% dan past",
      passRateHint: "O'tgan urinishlar ulushi",
      averageHint: "Barcha urinishlar bo'yicha",
      attemptsHint: "{count} ta o'quvchi",
      attemptsHint_plural: "{count} ta o'quvchi",
      tooltipAttempts: 'Urinishlar',
      chartDesc: "Urinishlar ball oralig'i bo'yicha",
      attemptsTableAria: 'Urinishlar jadvali',
      insightsDesc: "O'rtacha bali {percent}% dan past o'quvchilar.",
      attemptCount: '{count} ta urinish',
      attemptCount_plural: '{count} ta urinish',
      moreStudents: 'Yana {count} ta',
      questionLabel: '{index}-savol',
    },
    exams: {
      pageLead: "Yakuniy imtihon va har bir modul uchun imtihon yarating. Savollar qo'shing, o'tish balini va vaqt chegarasini belgilang.",
      newExam: 'Yangi imtihon',
      totalExams: 'Jami imtihonlar',
      published: 'Nashr qilingan',
      drafts: 'Qoralamalar',
      modulesWithoutExam: 'Imtihonsiz modullar',
      loadingExams: 'Imtihonlar yuklanmoqda...',
      loadExamsFailed: "Imtihonlarni yuklab bo'lmadi",
      accessDenied: "Sizda bu imtihonlarni ko'rish uchun ruxsat yo'q.",
      finalExamSection: 'Yakuniy imtihon',
      finalExamSectionDesc: 'Kurs oxirida topshiriladigan yakuniy baholovchi imtihon.',
      noFinalExamTitle: "Hozircha yakuniy imtihon yo'q",
      noFinalExamDesc: 'Yakuniy imtihon kursni umumiy baholash bilan yakunlaydi.',
      createFinalExamAction: 'Yakuniy imtihon yaratish',
      moduleExamsSection: 'Modul imtihonlari',
      moduleExamsSectionDesc: "Har bir modulning o'z imtihonlari bo'lishi mumkin: oxirida yoki darslar orasida.",
      noModulesTitle: "Hozircha modullar yo'q",
      noModulesDesc: "Avval Modullar bo'limida modullar yarating — shundan so'ng har bir modul o'z imtihoniga ega bo'ladi.",
      addExamForModule: "Imtihon qo'shish",
      practiceExamsSection: 'Mashq imtihonlari',
      practiceExamsSectionDesc: "Ma'lum bir modulga bog'liq bo'lmagan ixtiyoriy o'z-o'zini sinash imtihonlari.",
      statusPublished: 'Nashr qilingan',
      statusArchived: 'Arxivlangan',
      statusDraft: 'Qoralama',
      unpublish: 'Nashrdan olish',
      publish: 'Nashr qilish',
      edit: 'Tahrirlash',
      review: 'Tekshirish',
      reviewWithCount: 'Tekshirish ({count})',
      delete: "O'chirish",
      editExamTitle: 'Imtihonni tahrirlash',
      newExamTitle: 'Yangi imtihon',
      formSubtitle: "Imtihon sozlamalari va qoidalarini belgilang, so'ng savollar qo'shing.",
      examScopeLabel: 'Imtihon qamrovi',
      finalExamOption: 'Yakuniy imtihon',
      finalExamOptionSub: 'Kurs yakunidagi umumiy baholash',
      moduleExamOption: 'Modul imtihoni',
      moduleExamOptionSub: "Bitta modulga bog'liq",
      practiceOption: 'Mashq',
      practiceOptionSub: "Ixtiyoriy o'z-o'zini sinash",
      moduleLabel: 'Modul',
      selectModulePlaceholder: 'Modulni tanlang...',
      placementLabel: 'Qayerda turadi',
      placementEnd: 'Modul oxirida',
      placementAfter: '{index}-darsdan keyin: {title}',
      placementAfterShort: '{index}-darsdan keyin',
      placementHint: "Imtihon oldingi darslar tugagach ochiladi. Keyingi darslarni qulflamaydi.",
      categoryLabel: 'Kategoriya',
      categoryGeneral: 'Umumiy',
      categoryLanguage: 'Til',
      categoryMath: 'Matematika',
      subcategoryLabel: 'Subkategoriya',
      difficultyLabel: 'Qiyinlik',
      difficultyEasy: 'Oson',
      difficultyMedium: "O'rta",
      difficultyHard: 'Qiyin',
      difficultyMixed: 'Aralash',
      examKindLabel: 'Imtihon turi',
      examKindCheckpoint: 'Nazorat nuqtasi',
      examKindMock: 'Sinov imtihoni',
      examKindDrill: 'Tezkor mashq',
      examKindChallenge: "Sinov topshirig'i",
      examKindPlacement: 'Daraja aniqlash',
      titleLabel: 'Sarlavha',
      titlePlaceholder: 'masalan, 1-modul — Asoslar',
      descriptionLabel: 'Tavsif',
      descriptionPlaceholder: "O'quvchilar boshlashdan oldin ko'radigan qisqacha tavsif.",
      examInstructionsLabel: "Ko'rsatmalar",
      examInstructionsPlaceholder: "Imtihon sahifasida o'quvchilarga boshlashdan oldin ko'rsatiladi.",
      passingScoreLabel: "O'tish bali (%)",
      timeLimitLabel: 'Vaqt chegarasi (daq)',
      timeLimitPlaceholder: 'Chegarasiz',
      maxAttemptsLabel: 'Maksimal urinishlar',
      maxAttemptsPlaceholder: 'Cheklanmagan',
      sectionsLabel: "Bo'limlar",
      sectionsDesc: "Savollarni ko'nikma, mavzu yoki imtihon qismi bo'yicha guruhlang.",
      addSection: "Bo'lim qo'shish",
      newSectionDefaultTitle: "Yangi bo'lim",
      noSectionsYet: "Hozircha bo'limlar yo'q. Savollarni to'g'ridan-to'g'ri ham qo'shish mumkin.",
      sectionTitlePlaceholder: "Bo'lim sarlavhasi",
      skillSlugPlaceholder: "Ko'nikma identifikatori",
      instructionsPlaceholder: "Ko'rsatmalar",
      removeSection: "O'chirish",
      questionsLabel: 'Savollar',
      questionsDesc: "Tanlov javobli va erkin javobli savollarni qo'shing.",
      addQuestion: "Savol qo'shish",
      noQuestionsYet: "Hozircha savollar yo'q. Savollar qo'shilmaguncha imtihon qoralama bo'lib qoladi.",
      questionNumber: '{index}-savol',
      removeQuestion: "O'chirish",
      questionPromptPlaceholder: 'Savol matni',
      typeLabel: 'Turi',
      sectionLabel: "Bo'lim",
      noSectionOption: "Bo'limsiz",
      pointsLabel: 'Ball',
      optionsLabel: 'Variantlar yoki elementlar',
      optionsOrItemsPlaceholder: 'Har birini alohida qatorga, tartib bilan',
      matchingPairsLabel: 'Juftliklar',
      acceptedAnswersLabel: 'Qabul qilinadigan javoblar',
      correctAnswersLabel: "To'g'ri javoblar",
      correctAnswerLabel: "To'g'ri javob",
      toleranceLabel: "Ruxsat etilgan chegara",
      rubricLabel: 'Baholash mezonlari',
      explanationLabel: 'Izoh',
      matchingPairsPlaceholder: "Har birini alohida qatorga: chap=o'ng",
      acceptedAnswersPlaceholder: 'Har birini alohida qatorga',
      correctAnswersOrderPlaceholder: 'Har birini alohida qatorga, tartib bilan',
      correctAnswerPlaceholder: 'Javobni yozing',
      tolerancePlaceholder: 'masalan, 0.01',
      rubricPlaceholder: 'Baholash mezonlari qatorlari: mezon:ball:tavsif',
      explanationPlaceholder: "Javoblar ochilganda ko'rsatiladi",
      behaviourLabel: 'Imtihon qoidalari',
      showResultsLabel: "Topshirgandan keyin natijani ko'rsatish",
      showResultsHint: "O'quvchilar o'z balini darhol ko'radi.",
      showAnswersLabel: "To'g'ri javoblarni ochish",
      showAnswersHint: "O'quvchilar baholangandan keyin to'g'ri javoblarni ko'rishi mumkin.",
      shuffleQuestionsLabel: 'Savollarni aralashtirish',
      shuffleQuestionsHint: "Har bir urinishda savollar tasodifiy tartibda ko'rsatiladi.",
      shuffleOptionsLabel: 'Variantlarni aralashtirish',
      shuffleOptionsHint: "Ko'p tanlovli variantlar tasodifiy tartibda ko'rsatiladi.",
      cancel: 'Bekor qilish',
      saveChanges: "O'zgarishlarni saqlash",
      createExam: 'Imtihon yaratish',
      reviewAttempts: 'Urinishlarni tekshirish',
      loadingAttempts: 'Urinishlar yuklanmoqda...',
      noManualQuestionsTitle: "Qo'lda tekshiriladigan savollar yo'q",
      noManualQuestionsDesc: "Bu imtihon to'liq avtomatik baholanadi.",
      noSubmittedAttemptsTitle: "Yuborilgan urinishlar yo'q",
      noSubmittedAttemptsDesc: "Yuborilgan yozma yoki og'zaki urinishlar shu yerda ko'rinadi.",
      finalizeGrade: 'Bahoni yakunlash',
      scoreOutOf: 'Ball / {points}',
      noAnswerText: "Javob yo'q",
      close: 'Yopish',
      attemptStatus: {
        SUBMITTED: 'Yuborilgan',
        GRADED: 'Baholangan',
        IN_PROGRESS: 'Davom etmoqda',
        EXPIRED: "Muddati o'tgan",
      },
      loadAttemptsFailed: "Urinishlarni yuklab bo'lmadi",
      gradeAttemptFailed: "Urinishni baholab bo'lmadi",
      saveExamFailed: "Imtihonni saqlab bo'lmadi",
      changeStatusFailed: "Holatni o'zgartirib bo'lmadi",
      deleteExamFailed: "Imtihonni o'chirib bo'lmadi",
      discardTitle: 'Saqlamasdan chiqasizmi?',
      discardDesc: "Kiritilgan o'zgarishlar yo'qoladi.",
      discardAction: 'Chiqish',
      questionType: {
        MULTIPLE_CHOICE: 'Bitta tanlov',
        MULTI_SELECT: "Ko'p tanlov",
        TRUE_FALSE: "To'g'ri / noto'g'ri",
        FILL_BLANK: "Bo'shliqni to'ldirish",
        SHORT_ANSWER: 'Qisqa javob',
        NUMERIC: 'Raqamli',
        MATCHING: 'Moslashtirish',
        ORDERING: 'Tartiblash',
        ESSAY: 'Yozma ish / esse',
        SPEAKING: "Og'zaki javob",
      },
      category: {
        checkpoint: 'Nazorat nuqtasi',
        review: 'Takrorlash',
        grammar: 'Grammatika',
        vocabulary: "Lug'at",
        reading: "O'qish",
        listening: 'Tinglash',
        writing: 'Yozish',
        speaking: 'Gapirish',
        concepts: 'Tushunchalar',
        proceduralFluency: "Ko'nikmani mustahkamlash",
        wordProblems: 'Matnli masalalar',
        reasoning: 'Mantiqiy fikrlash',
        algebra: 'Algebra',
        geometry: 'Geometriya',
        data: "Ma'lumotlar",
        general: 'Umumiy',
      },
      addExamForModuleNamed: "{module} moduli uchun imtihon qo'shish",
      modulesWithoutExamDesc: 'Bu modullar uchun hali imtihon yaratilmagan.',
      deleteExamQuestion: "Imtihonni o'chirasizmi?",
      deleteExamDesc: "{title}: barcha savollar va o'quvchilar urinishlari o'chiriladi. Bu amalni bekor qilib bo'lmaydi.",
      publishedToast: 'Imtihon nashr qilindi',
      unpublishedToast: 'Imtihon nashrdan olindi',
      examSavedToast: 'Imtihon saqlandi',
      examDeletedToast: "Imtihon o'chirildi",
      gradeSavedToast: 'Baho saqlandi',
      questionsStat: '{count} savol',
      questionsStat_plural: '{count} savol',
      passStat: "{percent}% o'tish uchun",
      timeStat: '{count} daq',
      noTimeStat: 'Vaqt chegarasiz',
    },
    games: {
      pageSubtitle: "Darslaringizga biriktirilgan interaktiv hikoya va topishmoq o'yinlari.",
      gameCountLabel: "{count} ta o'yin",
      gameCountLabel_plural: "{count} ta o'yin",
      loadingGames: "O'yinlar yuklanmoqda...",
      accessDenied: "Sizda bu o'yinlarni ko'rish uchun ruxsat yo'q.",
      gamesInLesson: "Bu darsda {count} ta o'yin",
      gamesInLesson_plural: "Bu darsda {count} ta o'yin",
      newGame: "Yangi o'yin",
      addGame: "O'yin qo'shish",
      lessonLabel: 'Dars',
      selectLessonPlaceholder: 'Darsni tanlang...',
      gameTitleLabel: "O'yin nomi",
      descriptionLabel: 'Tavsif',
      noGamesForLesson: "Bu darsda hozircha o'yinlar yo'q.",
      noLessonsTitle: "O'yin biriktirish uchun darslar yo'q",
      noLessonsDesc: "Avval «Darslar» bo'limida dars qo'shing — o'yinlar darslar ustiga quriladi.",
      gameTitlePlaceholder: "O'yin nomi...",
      descriptionPlaceholder: 'Ixtiyoriy tavsif...',
      cancel: 'Bekor qilish',
      create: 'Yaratish',
      delete: "O'chirish",
      gameCreated: "O'yin yaratildi",
      createGameFailed: "O'yinni yaratib bo'lmadi",
      gameDeleted: "O'yin o'chirildi",
      deleteGameFailed: "O'chirib bo'lmadi",
      nodesCount: 'Qadamlar: {count}',
      addNode: "Qadam qo'shish",
      nodeTextPlaceholder: "O'quvchi bu qadamda nimani o'qiydi...",
      pointsPlaceholder: 'Ball',
      startLabel: 'Birinchi qadam',
      add: "Qo'shish",
      addNodeFailed: "Qadamni qo'shib bo'lmadi",
      addChoiceFailed: "Tanlovni qo'shib bo'lmadi",
      noNodesHint: "Hozircha qadamlar yo'q. Birinchi qadamni qo'shing — hikoya shundan boshlanadi.",
      startBadge: 'Birinchi qadam',
      pointsSuffix: 'ball',
      choiceLabelPlaceholder: 'Tanlov matni...',
      leadsToPlaceholder: 'Keyingi qadam...',
      gameTypeLabel: "O'yin turi",
      nodeTypeLabel: 'Qadam turi',
      addChoice: "Tanlov qo'shish",
      puzzlesCount: 'Topishmoqlar: {count}',
      addPuzzle: "Topishmoq qo'shish",
      addPuzzleFailed: "Topishmoqni qo'shib bo'lmadi",
      questionPromptLabel: 'Savol / topshiriq',
      questionPromptPlaceholder: "O'quvchi qanday savolni ko'radi?",
      correctAnswerLabel: "To'g'ri javob",
      correctAnswerPlaceholder: 'Kutilayotgan javob',
      hintsLabel: 'Maslahatlar (har birini alohida qatorga)',
      hintsPlaceholder: 'Ixtiyoriy maslahatlar',
      pointsLabel: 'Ball',
      addPuzzleBtn: "Topishmoq qo'shish",
      noPuzzlesHint: "Hozircha topishmoqlar yo'q. Boshlash uchun birinchisini qo'shing.",
      answerLabel: 'Javob:',
      hintsPrefix: 'Maslahatlar:',
      nodeType: {
        PROMPT: 'Tanlovli qadam',
        TERMINAL: 'Hikoya oxiri',
      },
      gameType: {
        STORY_ADVENTURE: 'Hikoyaviy sarguzasht',
        PUZZLE_MASTER: 'Topishmoqlar ustasi',
        SIMULATOR: 'Simulyator',
        SKILL_QUEST: "Ko'nikma sarguzashti",
        PICTURE_QUIZ: 'Rasmli viktorina',
        MEMORY_MATCH: "Xotira o'yini",
        SENTENCE_BUILDER: 'Gap tuzish',
        WORD_SPRINT: "So'z sprinti",
      },
      kpiTotal: "Jami o'yinlar",
      kpiLessons: "O'yinli darslar",
      kpiAuthored: "Qo'lda yaratilgan",
      kpiAuto: 'Avtomatik',
      deleteTitle: "O'yinni o'chirasizmi?",
      deleteDesc: "Bu amalni bekor qilib bo'lmaydi.",
      autoNote: "Bu o'yin darsning lug'at so'zlaridan avtomatik tuziladi, shuning uchun bu yerda tahrirlanmaydi.",
      notEditableNote: "Bu turdagi o'yinni bu yerda tahrirlab bo'lmaydi.",
      nodesMeta: '{count} ta qadam',
      nodesMeta_plural: '{count} ta qadam',
      puzzlesMeta: '{count} ta topishmoq',
      puzzlesMeta_plural: '{count} ta topishmoq',
    },
    common: {
      close: 'Yopish',
    },
  },
};

export default courseAssess;
